import { CRITERIA_TYPES } from '@highlight-cp/project-api';
import type { AudienceBuilderTestGroup } from '@highlight-cp/project-api';

/**
 * ### getCustomCriteriaLabelsFromTestGroups
 *
 * @description
 * Extracts unique custom criteria labels from recruiting test groups by collecting
 * partition answer values from quotas with type CustomTag.
 *
 * @param testGroups - Test groups from recruiting data (e.g. spec.audience.testGroups)
 * @returns Deduplicated array of non-empty label strings
 */
export const getCustomCriteriaLabelsFromTestGroups = (
  testGroups: AudienceBuilderTestGroup[] | null | undefined,
): string[] => {
  const groups = testGroups ?? [];
  return [
    ...new Set(
      groups.flatMap((group) =>
        (group.quotas ?? [])
          .filter((quota) => quota.type === CRITERIA_TYPES.CUSTOM_TAG)
          .flatMap((quota) =>
            (quota.partitions ?? []).flatMap((partition) => partition.answers?.values ?? []),
          ),
      ),
    ),
  ].filter((v): v is string => v != null && v !== '');
};
